import { useTranslation } from 'react-i18next';

import { Logger } from '@/lib/logs/logger';

type I18StringProps = {
  i18nPath: string;
  className?: string;
  values?: { [key: string]: string | number };
};

export const I18String = ({ i18nPath, className, values }: I18StringProps) => {
  const { t } = useTranslation();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const translatedText = t(i18nPath as any, values);
  const enviroment = process.env.NODE_ENV;

  if (translatedText === i18nPath && enviroment !== 'test') {
    Logger.error(`Translation for "${i18nPath}" not found.`);

    if (enviroment === 'development') {
      throw new Error(`Translation for "${i18nPath}" not found.`);
    }
  }

  return <span className={className}>{translatedText}</span>;
};
